{
  "app": {
    "title": "AI Deck",
    "description": "Build a deck of your favorite AI tools."
  },
  "nav": {
    "home": "Home",
    "services": "Services",
    "serviceList": "Service List",
    "articles": "Articles",
    "favorites": "Favorites",
    "settings": "User Settings",
    "admin": "Admin",
    "adminPanel": "Admin Panel",
    "adminServices": "Services",
    "adminUsers": "Users",
    "adminBanners": "Banners",
    "userMenu": "User menu",
    "help": "Help",
    "legalInfo": "Legal",
    "mainNavigation": "Main navigation",
    "adminApiKeys": "API Keys"
  },
  "language": {
    "switch": "Language",
    "en": "English",
    "ja": "日本語",
    "switchToEn": "Switch to English",
    "switchToJa": "Switch to Japanese"
  },
  "services": {
    "title": "AI Services",
    "search": "Search services...",
    "searchNameOnly": "Search by service name...",
    "searchWithShortcut": "Search by service name, description, etc... [{{shortcut}}]",
    "noResults": "No services found",
    "noResultsTitle": "No services found",
    "noResultsDescription": "Try changing your search criteria.",
    "clearFilters": "Clear filters",
    "addToFavorites": "Add to favorites",
    "removeFromFavorites": "Remove from favorites",
    "hideService": "Hide service",
    "showService": "Show service",
    "resetToDefault": "Reset to default",
    "clickToOpen": "Click to open service",
    "tags": "Tags",
    "favoriteCount": "{{count}} favorites",
    "clickCount": "{{count}} clicks",
    "cardActions": "Actions for {{name}}",
    "descriptionPopover": "View the description of {{name}}",
    "descriptionWithArticle": "Description and guide for {{name}}",
    "readArticle": "Read the guide",
    "noDescription": "No description has been added yet.",
    "mcpDocsLink": "MCP documentation for {{name}}",
    "deckFavoriteTooltip": "Remove / Favorites: {{total}}",
    "deckFavoriteAriaLabel": "Remove from favorites (favorites: {{total}})",
    "featured": {
      "title": "Featured Services",
      "carouselNavigation": "Use arrow keys to navigate"
    },
    "badges": {
      "group": "Service badges",
      "editorPick": "Editor's pick",
      "trending": "Trending service",
      "popular": "Popular service",
      "myService": "My Service"
    },
    "addItemDropdown": "Add Item",
    "removeLastTag": "Remove last tag",
    "requestService": "Request a service",
    "searching": "Searching",
    "shortcutHint": "Press {{shortcut}} to search",
    "searchScope": {
      "nameOnly": "Name only",
      "nameOnlyHint": "Search names and providers only (excludes descriptions and tags)",
      "nameOnlyAria": "Search names and providers only",
      "nameOnlyShort": "Name"
    },
    "filteringLabel": "Active filters",
    "searchChip": "Search: {{query}}",
    "clearAllFilters": "Clear all",
    "filteredCount": "{{count}} of {{total}}",
    "removeTagFilterAria": "Remove tag filter: {{name}}",
    "clearSearchAria": "Clear search keyword",
    "loadError": {
      "title": "Couldn't load the service list",
      "description": "Check your network connection and try again.",
      "retry": "Reload"
    },
    "discontinuedBadge": "Discontinued"
  },
  "serviceLinks": {
    "home": "Home",
    "document": "Documentation",
    "api": "API",
    "changelog": "Changelog",
    "blog": "Blog",
    "price": "Pricing",
    "learn": "Learn",
    "faq": "FAQ",
    "github": "GitHub",
    "x": "X (Twitter)",
    "linkedin": "LinkedIn",
    "facebook": "Facebook",
    "instagram": "Instagram",
    "tiktok": "TikTok",
    "discord": "Discord",
    "youtube": "YouTube",
    "productHunt": "Product Hunt"
  },
  "favorites": {
    "title": "My Deck",
    "empty": "No favorite services yet",
    "emptyDescription": "Add heart marks to AI tools you're interested in to create your favorites list.",
    "addSome": "Add some services to your favorites from the home page",
    "reorder": "Drag to reorder",
    "dragAndDropHint": "Drag & drop to reorder. Click the icon at bottom-left to change color",
    "helpButton": "Show usage tips",
    "helpModalTitle": "How to Use",
    "helpModalItem1Part1": "In the service list, click the",
    "helpModalItem1Part2": "on your favorite service card to add it to this page",
    "helpModalItem2": "to drag & drop and reorder services",
    "helpModalItem3": "Click the icon at bottom-left to change color. You can hide it in settings.",
    "helpModalItem4": "Add up to 10 decks using the Add Deck button",
    "helpModalItem5": "Click deck name to edit (adding emojis makes them easier to read)",
    "helpModalItem6": "to view related links and memos (including private memos) on hover/click",
    "helpModalItem7": "to edit service details",
    "browseServices": "Browse Services",
    "addDeck": "Add Deck",
    "addDeckTitle": "Add a new deck",
    "emptyAreaMessage": "Drag & drop services here",
    "emptyAreaHint": "(Tip: Click deck name to edit)",
    "confirmRemove": "Remove from favorites?",
    "confirmRemoveButton": "Remove",
    "confirmCancelButton": "Cancel"
  },
  "settings": {
    "title": "Settings",
    "description": "Manage your account settings",
    "tabs": {
      "profile": "Profile",
      "security": "Security",
      "memo": "Memo",
      "plan": "Plan",
      "danger": "Delete Account",
      "dangerShort": "Delete",
      "developer": "API Keys"
    },
    "memo": {
      "description": "Manage encryption and backups (export / import) for your private memos"
    },
    "profile": {
      "title": "Profile Settings",
      "description": "Edit your account's basic information",
      "name": "Display Name",
      "namePlaceholder": "John Doe",
      "nameHelp": "Maximum 20 characters",
      "preview": "Preview",
      "imageAlt": "Profile image",
      "reset": "Reset",
      "saving": "Saving...",
      "save": "Save Changes",
      "noChanges": "No Changes",
      "noChangesDescription": "No changes to save",
      "saveSuccess": "Saved",
      "saveSuccessDescription": "Profile updated successfully",
      "error": "Error",
      "errorDescription": "Failed to update profile",
      "loadError": "Failed to load profile information"
    },
    "avatar": {
      "title": "Profile Image",
      "description": "Choose from 6 styles",
      "selectStyle": "Select a style",
      "styles": {
        "robot": "Robot",
        "character": "Character",
        "geometric": "Geometric",
        "abstract": "Abstract",
        "thumbs": "Thumbs",
        "initials": "Initials"
      },
      "ariaLabel": {
        "styleButton": "Select avatar style '{{style}}'",
        "currentStyle": "(Currently selected)"
      }
    },
    "password": {
      "title": "Change Password",
      "description": "Change your account password",
      "notice": "You will not be automatically logged out after changing your password. The new password will take effect on your next login.",
      "currentPassword": "Current Password",
      "currentPasswordPlaceholder": "Enter current password",
      "newPassword": "New Password",
      "newPasswordPlaceholder": "Enter new password (8+ characters)",
      "newPasswordHelp": "Must be 8-128 characters. We recommend combining letters, numbers, and symbols.",
      "confirmPassword": "Confirm New Password",
      "confirmPasswordPlaceholder": "Re-enter new password",
      "reset": "Reset",
      "changing": "Changing...",
      "change": "Change Password",
      "strength": "Password Strength:",
      "strengthVeryWeak": "Very Weak",
      "strengthWeak": "Weak",
      "strengthFair": "Fair",
      "strengthStrong": "Strong",
      "strengthVeryStrong": "Very Strong",
      "changeSuccess": "Password Changed",
      "strengthRecommendation": "Password Strength Recommendations",
      "error": "Error",
      "errorDescription": "Failed to change password",
      "validation": {
        "currentPasswordRequired": "Please enter your current password",
        "newPasswordRequired": "Please enter a new password",
        "newPasswordTooShort": "Password must be at least 8 characters",
        "newPasswordTooLong": "Password must be 128 characters or less",
        "confirmPasswordRequired": "Please confirm your password",
        "passwordMismatch": "New password and confirmation do not match"
      }
    },
    "security": {
      "title": "Security & Account Information",
      "description": "View and manage your account's security settings",
      "email": "Email Address",
      "changeEmail": "Change",
      "changeEmailTitle": "Change Email Address",
      "changeEmailDescription": "Enter your new email address. A verification email will be sent after the change.",
      "currentEmail": "Current Email Address",
      "newEmail": "New Email Address",
      "newEmailPlaceholder": "new@example.com",
      "cancel": "Cancel",
      "changing": "Changing...",
      "change": "Change",
      "verified": "Verified",
      "unverified": "Unverified",
      "resendingVerification": "Sending...",
      "resendVerification": "Resend Verification Email",
      "accountInfo": "Account Information",
      "userId": "User ID:",
      "role": "Role:",
      "roleAdmin": "Administrator",
      "roleUser": "User",
      "status": "Account Status:",
      "statusActive": "Active",
      "registeredAt": "Registered:",
      "lastLogin": "Last Login:",
      "totalClicks": "Total Clicks:",
      "totalClicksSuffix": " times",
      "lastClickAt": "Last Click:",
      "none": "None",
      "inputError": "Input Error",
      "emailRequired": "Please enter a new email address",
      "emailInvalid": "Please enter a valid email address",
      "noChanges": "No Changes",
      "emailSame": "This is the same as your current email address",
      "emailChangeSuccess": "Verification Email Sent",
      "emailChangeVerificationSent": "A verification email has been sent to your new email address. Please click the link in the email to complete the change.",
      "error": "Error",
      "emailChangeError": "Failed to change email address",
      "verificationSentSuccess": "Verification Email Sent",
      "verificationSentError": "Failed to send verification email",
      "loadError": "Failed to load security information"
    },
    "plan": {
      "title": "Plan & Subscription",
      "description": "Review your current plan and manage your subscription",
      "currentPlan": "Current Plan",
      "manageSubscription": "Manage Subscription",
      "viewPlans": "View Plans",
      "upgradeToPro": "Upgrade to Pro",
      "checkoutSuccess": "Upgrade to Pro completed",
      "checkoutSuccessDescription": "Thank you for upgrading. Enjoy all Pro features.",
      "portalError": "Couldn't open the subscription management page",
      "portalErrorDescription": "Please try again in a moment. If the problem persists, contact us."
    },
    "language": "Language",
    "theme": "Theme",
    "notifications": "Notifications",
    "background": {
      "title": "Background",
      "colorLabel": "Color",
      "patternLabel": "Pattern",
      "reset": "Reset"
    },
    "backgroundColor": {
      "blue": "Blue",
      "pink": "Pink",
      "yellow": "Yellow",
      "green": "Green",
      "purple": "Purple",
      "gray": "Gray",
      "midnight": "Midnight",
      "charcoal": "Charcoal"
    },
    "backgroundPattern": {
      "title": "Background Pattern",
      "none": "None",
      "dots": "Dots",
      "stripes": "Stripes",
      "grid": "Grid",
      "waves": "Waves",
      "checkerboard": "Check",
      "cross": "Cross"
    },
    "deleteAccount": {
      "title": "Delete Account",
      "description": "Permanently delete your account. This action cannot be undone.",
      "subscriptionWarning": {
        "title": "You have an active subscription",
        "description": "Deleting your account will not automatically cancel your subscription. Please cancel your subscription before deleting your account.",
        "manageButton": "Manage Subscription"
      },
      "button": "Delete Account",
      "confirmTitle": "Are you sure you want to delete your account?",
      "confirmDescription": "This action cannot be undone. Your account and all data will be permanently deleted.",
      "warning": {
        "title": "Warning",
        "dataWillBeDeleted": "The following data will be permanently deleted:",
        "accountInfo": "Account information (email, password, profile)",
        "favorites": "Favorite settings",
        "customizations": "Customization settings (services, tags)",
        "requests": "Service request history",
        "irreversible": "This action cannot be undone."
      },
      "form": {
        "passwordLabel": "Enter your password",
        "passwordPlaceholder": "Password",
        "confirmationLabel": "Type 'DELETE' to confirm",
        "confirmationPlaceholder": "DELETE",
        "understood": "I understand. Delete my account."
      },
      "buttons": {
        "cancel": "Cancel",
        "deleting": "Deleting...",
        "delete": "Delete"
      },
      "toast": {
        "errorTitle": "Input Error",
        "allFieldsRequired": "Please fill in all fields",
        "confirmationMismatch": "Please type 'DELETE' exactly",
        "successTitle": "Account deleted",
        "successDescription": "Thank you for using our service",
        "deleteErrorTitle": "Delete Error",
        "deleteErrorDescription": "Failed to delete account"
      }
    },
    "apiKeys": {
      "title": "API Keys",
      "description": "Create and manage keys to access the public API and MCP server.",
      "docsLink": "View developer documentation",
      "usage": "Using {{count}} of {{limit}} keys",
      "createButton": "Create key",
      "limitReached": "You've reached your key limit ({{limit}}). Revoke an unused key to create a new one.",
      "upgradeCta": "Upgrade to Pro for a higher limit",
      "loadError": "Failed to load API keys",
      "empty": "You don't have any API keys yet. Create one with \"Create key\".",
      "revokedBadge": "Revoked",
      "createdAt": "Created",
      "lastUsed": "Last used",
      "never": "Never",
      "revokeButton": "Revoke",
      "createDialogTitle": "Create API key",
      "createDialogDescription": "Give the key a name so you can identify it (e.g. Production, Development).",
      "nameLabel": "Key name",
      "namePlaceholder": "e.g. Production",
      "scopeLabel": "Scope",
      "scopeRead": "Read-only",
      "scopeReadDescription": "Search the catalog and read your own deck.",
      "scopeReadWrite": "Read & write",
      "scopeReadWriteDescription": "Allows writing to your deck (adding and moving services). Required for the MCP writing tools.",
      "scopeReadBadge": "Read",
      "scopeReadWriteBadge": "Read & write",
      "cancel": "Cancel",
      "create": "Create",
      "creating": "Creating...",
      "createErrorTitle": "Failed to create",
      "createError": "Failed to create the API key",
      "createdTitle": "API key created",
      "createdWarning": "This key is shown only once. You won't be able to see it again after closing this dialog. Store it somewhere safe.",
      "copy": "Copy",
      "copyError": "Failed to copy",
      "doneButton": "Done",
      "revokeConfirmTitle": "Revoke this API key?",
      "revokeConfirmDescription": "This will revoke \"{{name}}\". This action can't be undone, and any app using this key will lose access.",
      "revoking": "Revoking...",
      "revokeSuccess": "API key revoked",
      "revokeErrorTitle": "Failed to revoke",
      "revokeError": "Failed to revoke the API key"
    }
  },
  "auth": {
    "loginTitle": "Login",
    "signupTitle": "Sign Up",
    "login": "Login",
    "logout": "Logout",
    "signup": "Sign Up",
    "signIn": "Sign In",
    "signingIn": "Signing in...",
    "createAccount": "Create Account",
    "creatingAccount": "Creating account...",
    "email": "Email",
    "password": "Password",
    "confirmPassword": "Confirm Password",
    "passwordHint": "Please enter at least 8 characters",
    "forgotPassword": "Forgot password?",
    "forgotPasswordTitle": "Reset Password",
    "forgotPasswordDescription": "Enter your registered email address. We'll send you a link to reset your password.",
    "sendResetLink": "Send Reset Link",
    "sendingResetLink": "Sending...",
    "resetLinkSent": "Reset link sent",
    "resetLinkSentDescription": "Please check your email. We've sent you a password reset link. If you don't see it, check your spam folder.",
    "resetPasswordTitle": "Set New Password",
    "newPassword": "New Password",
    "newPasswordPlaceholder": "At least 8 characters",
    "confirmNewPassword": "Confirm New Password",
    "resetPassword": "Reset Password",
    "resettingPassword": "Resetting...",
    "resetPasswordSuccess": "Password has been reset. Please log in with your new password.",
    "invalidResetToken": "Invalid or expired reset link. Please try resetting your password again.",
    "backToLogin": "Back to login",
    "noAccount": "Don't have an account?",
    "hasAccount": "Already have an account?",
    "signUpHere": "Sign up here",
    "loginHere": "Login here",
    "backToTop": "» Back to top",
    "or": "or",
    "errors": {
      "userAlreadyExists": "This email address is already registered. Please log in from the login screen.",
      "invalidEmailOrPassword": "The email address or password is incorrect.",
      "emailNotVerified": "Your email address has not been verified yet. Please click the link sent to your inbox.",
      "passwordTooShort": "Password must be at least 8 characters.",
      "unknown": "An unexpected error occurred. Please try again later."
    }
  },
  "verifyEmail": {
    "verifying": "Verifying your email...",
    "successTitle": "Email Verified",
    "successMessage": "Your email address has been verified successfully.",
    "redirectMessage": "Redirecting to dashboard in 3 seconds...",
    "goToDashboardNow": "Go to Dashboard Now",
    "expiredTitle": "Verification Link Expired",
    "expiredMessage": "The verification link has expired",
    "expiredInstruction": "Please request a new verification email from the settings page.",
    "errorTitle": "Email Verification Error",
    "errorDefault": "Email verification failed",
    "tokenNotFound": "Verification token not found",
    "tokenInvalid": "Invalid verification token",
    "unexpectedError": "An unexpected error occurred",
    "goToDashboard": "Go to Dashboard",
    "goToHome": "Go to Home"
  },
  "error": {
    "pageTitle": "Something went wrong",
    "pageMessage": "We're sorry, something unexpected happened. Please try reloading the page or return to home.",
    "sectionTitle": "Unable to load content",
    "sectionMessage": "An error occurred while displaying this section.",
    "inlineMessage": "An error occurred",
    "retry": "Try again",
    "goHome": "Go to Home",
    "showDetails": "Show details (for developers)"
  },
  "errorHandler": {
    "network": {
      "title": "Connection Error",
      "description": "Unable to connect to the network. Please check your connection."
    },
    "auth": {
      "title": "Authentication Error",
      "description": "Your session has expired. Please log in again."
    },
    "validation": {
      "title": "Input Error",
      "description": "Please check your input."
    },
    "server": {
      "title": "Server Error",
      "description": "A server error occurred. Please try again later."
    },
    "rateLimit": {
      "title": "Rate Limit",
      "description": "Too many requests. Please try again later."
    },
    "notFound": {
      "title": "Not Found",
      "description": "The requested resource was not found."
    },
    "unknown": {
      "title": "Error",
      "description": "An unexpected error occurred."
    }
  },
  "common": {
    "loading": "Loading...",
    "error": "An error occurred",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "close": "Close",
    "confirm": "Confirm",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "submit": "Submit",
    "reset": "Reset"
  },
  "messages": {
    "saveSuccess": "Saved successfully",
    "saveError": "Failed to save",
    "deleteSuccess": "Deleted successfully",
    "deleteError": "Failed to delete",
    "updateSuccess": "Updated successfully",
    "updateError": "Failed to update"
  },
  "ui": {
    "tags": "Tags",
    "clear": "Clear",
    "tagCategories": {
      "ecosystem": "Ecosystem",
      "function": "Use Case",
      "attribute": "Attributes"
    },
    "settings": "Settings",
    "viewSettings": "View Settings",
    "close": "Close",
    "enabled": "Enabled",
    "serviceName": "Service Name",
    "cardDesign": "Card Design",
    "cardStyleStandard": "Standard",
    "cardStyleFlat": "Flat",
    "displayFields": "Display Fields",
    "fieldProvider": "Provider",
    "fieldDescription": "Description",
    "fieldReleaseDate": "Release Date",
    "fieldDevCountry": "Country",
    "fieldTags": "Tags",
    "presetMinimal": "Minimal",
    "presetFull": "Full",
    "privateMemoDisplay": "Show Private Memo",
    "privateMemoDisplayDescription": "When off, the Private Memo field is hidden on each service.",
    "ariaLabelTogglePrivateMemo": "Toggle Private Memo display",
    "colorPickerDisplay": "Show Color Picker",
    "colorPickerDisplayDescription": "When off, the color picker only appears on card hover.",
    "ariaLabelToggleColorPicker": "Toggle Color Picker display",
    "sortBy": "Sort by",
    "sortFavoriteDesc": "Most popular",
    "sortCreatedDesc": "Newest first",
    "sortNameAsc": "Name (A→Z)",
    "sortNameDesc": "Name (Z→A)",
    "ariaLabelCloseSettings": "Close settings",
    "totalServices": "Total",
    "favoriteServices": "Favorites",
    "customized": "Customized",
    "ariaLabelTotalServices": "Total services: {{count}}",
    "ariaLabelFavoriteServices": "Favorites: {{count}}",
    "ariaLabelCustomizedServices": "Customized: {{count}}",
    "ariaLabelServiceStats": "Service statistics",
    "serviceCounter": "{{current}}/{{total}}",
    "ariaLabelServiceCounter": "Showing {{current}} of {{total}} services",
    "tagSelected": "{{name}} (selected)",
    "tagUnselected": "{{name}} (not selected)"
  },
  "admin": {
    "newService": "Add New Service",
    "editService": "Edit Service",
    "newServiceDescription": "Add a new service. Please fill in the required fields.",
    "editServiceDescription": "Edit service information. Please fill in the required fields."
  },
  "adminBanners": {
    "title": "Banner Management",
    "description": "Manage the wide banners shown above the service list. Drag to reorder.",
    "create": "New Banner",
    "empty": "No banners yet. Add one from \"New Banner\".",
    "loading": "Loading banners",
    "loadError": "Failed to load banners",
    "columns": {
      "reorder": "Reorder",
      "thumbnail": "Thumbnail",
      "alt": "ALT",
      "link": "Link",
      "period": "Period",
      "status": "Status",
      "active": "Active",
      "actions": "Actions"
    },
    "period": {
      "always": "Always",
      "fromOnly": "{{start}} –",
      "untilOnly": "– {{end}}",
      "range": "{{start}} – {{end}}"
    },
    "status": {
      "active": "Live",
      "scheduled": "Scheduled",
      "ended": "Ended",
      "disabled": "Disabled"
    },
    "prBadge": "PR",
    "linkType": {
      "internal": "Internal",
      "external": "External"
    },
    "form": {
      "createTitle": "New Banner",
      "editTitle": "Edit Banner",
      "imageUrl": "Image URL",
      "imageUrlPlaceholder": "https://images.ai-deck.app/banners/xxxx.webp",
      "imageHint": "Recommended 1200×400px (3:1), WebP, ~200KB",
      "imagePreviewError": "Cannot load image",
      "alt": "ALT (alt text)",
      "altEn": "ALT (English, optional)",
      "linkUrl": "Link URL",
      "linkUrlHint": "Start with \"/\" for internal links (e.g. /services?tags=xxx), http(s):// for external",
      "startDate": "Start date",
      "endDate": "End date",
      "clear": "Clear",
      "isAd": "Ad banner",
      "isAdHint": "When ON, hidden from Pro plans (shows a PR badge)",
      "isActive": "Active",
      "save": "Save",
      "cancel": "Cancel"
    },
    "actions": {
      "edit": "Edit",
      "delete": "Delete"
    },
    "deleteConfirm": {
      "title": "Delete this banner?",
      "description": "This action cannot be undone. The banner will be permanently deleted.",
      "confirm": "Delete",
      "cancel": "Cancel"
    },
    "toast": {
      "created": "Banner created",
      "updated": "Banner updated",
      "deleted": "Banner deleted",
      "activated": "Banner activated",
      "deactivated": "Banner deactivated",
      "reordered": "Order saved",
      "saveError": "Failed to save banner",
      "deleteError": "Failed to delete banner",
      "toggleError": "Failed to change status",
      "reorderError": "Failed to save order",
      "validationError": "Please check your input"
    }
  },
  "date": {
    "unknown": "Unknown date",
    "lessThanHour": "Less than 1 hour",
    "hoursAgo": "{{count}} hours ago",
    "daysAgo": "{{count}} days ago"
  },
  "privateMemo": {
    "title": "Private Memo",
    "placeholder": "Private memo (max {{max}} characters)",
    "description": "Not sent to server. Data is stored on your local device.",
    "ariaLabel": "Private memo",
    "saving": "Saving...",
    "saved": "Saved",
    "delete": "Delete private memo",
    "deleteConfirmTitle": "Delete Private Memo",
    "deleteConfirmDescription": "Are you sure you want to delete this private memo? This action cannot be undone.",
    "showMemo": "Show memo",
    "hiddenMessage": "Display is off. To show, enable Settings button → Private Memo Display",
    "manager": {
      "title": "Private Memo Manager",
      "currentCountLabel": "Current notes",
      "currentCount": "{{count}}",
      "exportHeading": "Export",
      "exportDescription": "Save all private memos as a JSON file",
      "exportButton": "Export",
      "exportEmpty": "No memos yet",
      "importHeading": "Import",
      "importDescription": "Restore private memos from a JSON file",
      "modeLabel": "Import mode",
      "modeMerge": "Merge (keep existing)",
      "modeOverwrite": "Overwrite (remove existing)",
      "selectFile": "Select file",
      "importing": "Importing...",
      "resultSuccessTitle": "Import succeeded",
      "resultFailureTitle": "Import failed",
      "resultImported": "Imported {{count}} memo(s)",
      "resultSkipped": "Skipped {{count}} memo(s)",
      "resultFailed": "Failed to import",
      "detailsHeading": "Details:",
      "skippedItemsLabel": "Skipped items ({{count}})",
      "moreCount": "... and {{count}} more",
      "errorInvalidId": "Unknown service ID",
      "errorContentSanitized": "Removed invalid characters",
      "errorEmptyAfterSanitize": "Became empty after sanitization",
      "errorTooLong": "Exceeded character limit",
      "noticeLabel": "Note:",
      "noticeBody": "Private memos are stored only in this device's localStorage and are never sent to the server. Please keep exported files in a safe place."
    },
    "utils": {
      "fileTooLarge": "File is too large (max {{max}} MB)",
      "invalidFormat": "Invalid data format",
      "missingFields": "Required fields are missing",
      "unsupportedVersion": "Unsupported version: {{version}}",
      "notesNotObject": "The notes field must be an object",
      "invalidEntry": "Invalid memo entry: {{key}} = {{type}}",
      "tooManyNotes": "Too many memos (max {{max}})",
      "sanitizedNotes": "Removed invalid characters from {{count}} memo(s)",
      "skippedUnknownIds": "Skipped {{count}} unknown service ID(s)",
      "unknownError": "An unknown error occurred"
    },
    "encryption": {
      "heading": "Encryption",
      "plaintextDescription": "Set a passphrase to encrypt your memos on this device. This makes them a safe place for sensitive notes such as service IDs and passwords.",
      "plaintextNotice": "For sensitive information such as passwords, enable encryption first.",
      "plaintextNoticeAction": "Set up encryption",
      "encryptedNotice": "Not sent to the server. Encrypted and stored on your device.",
      "enableButton": "Enable encryption",
      "enableConfirmButton": "Encrypt",
      "enabling": "Encrypting...",
      "enableError": "Failed to enable encryption",
      "passphraseLabel": "Passphrase (at least {{min}} characters)",
      "passphraseConfirmLabel": "Passphrase (confirm)",
      "passphrasePlaceholder": "Passphrase",
      "forgotWarning": "If you forget your passphrase, your memos cannot be recovered. The only way out is deleting all memos (reset). Keep your passphrase in a safe place.",
      "tooShort": "Passphrase must be at least {{min}} characters",
      "mismatch": "Passphrases do not match",
      "lockedStatus": "Locked",
      "lockedMessage": "Your memos are encrypted. Enter your passphrase to unlock them.",
      "unlockButton": "Unlock",
      "unlocking": "Unlocking...",
      "wrongPassphrase": "Wrong passphrase",
      "enabledStatus": "Encryption is enabled (unlocked)",
      "disableButton": "Disable encryption",
      "disableConfirmTitle": "Disable encryption?",
      "disableConfirmDescription": "Your memos will be stored without encryption again. If you keep sensitive notes such as passwords, we recommend deleting them first.",
      "disableConfirmButton": "Disable",
      "resetButton": "Reset (delete all memos)",
      "resetConfirmTitle": "Delete all memos?",
      "resetConfirmDescription": "This deletes all private memos and turns off encryption. This cannot be undone. It is the only recovery option if you forgot your passphrase.",
      "exportEncryptedDescription": "Exports your memos while they stay encrypted. Importing requires the passphrase used when the backup was created.",
      "exportEncryptedButton": "Export encrypted backup",
      "exportPlainButton": "Export without encryption",
      "exportPlainConfirmTitle": "Export without encryption?",
      "exportPlainConfirmDescription": "The exported file will not be encrypted. Handle it with care if it contains sensitive notes.",
      "exportPlainConfirmButton": "Export",
      "importLockedMessage": "Import is unavailable while locked. Unlock your memos first.",
      "importPassphraseLabel": "Backup passphrase",
      "importEncryptedDetected": "An encrypted backup was selected. Enter the passphrase used when it was created.",
      "importDecryptButton": "Decrypt and import",
      "nudgeTitle": "Encrypt your private memos?",
      "nudgeTradeoffs": "Note: if you forget your passphrase, your memos cannot be recovered \u2014 deleting them all is the only way out. You will also need to unlock your memos each time you reopen the page. You can enable or disable encryption anytime from the \"Memo\" tab in Settings.",
      "nudgeLater": "Not now"
    }
  },
  "memo": {
    "title": "Memo"
  },
  "countries": {
    "US": "United States",
    "CN": "China",
    "GB": "United Kingdom",
    "IL": "Israel",
    "CA": "Canada",
    "FR": "France",
    "IN": "India",
    "JP": "Japan",
    "DE": "Germany",
    "SG": "Singapore",
    "KR": "South Korea",
    "AU": "Australia",
    "CH": "Switzerland",
    "SE": "Sweden",
    "AE": "United Arab Emirates (UAE)"
  },
  "pages": {
    "userGuide": "User Guide",
    "pricing": "Pricing",
    "faq": "FAQ",
    "changelog": "Changelog",
    "feedback": "Contact",
    "developers": "Developer API",
    "archive": {
      "title": "Discontinued Services",
      "metaDescription": "A record of AI services that have been discontinued, with the discontinuation date and the last known description.",
      "lead": "A record of AI services that have been discontinued. They are not counted in the catalog total, but we keep the information as of their discontinuation here so you can look back on what once existed.",
      "discontinuedOn": "Discontinued on {{date}}",
      "source": "Source",
      "article": "Article",
      "empty": "No discontinued services yet.",
      "error": "Couldn't load the list of discontinued services. Please try again later."
    }
  },
  "legal": {
    "title": "Legal",
    "terms": "Terms of Service",
    "privacy": "Privacy Policy",
    "commercial": "Commercial Disclosure",
    "sellerInfo": "Seller Information",
    "refund": "Refund & Cancellation Policy",
    "lastUpdated": "Last updated: {{date}}",
    "japaneseVersionNote": "The Japanese version is the official text. This English version is provided for reference only."
  },
  "footer": {
    "terms": "Terms",
    "privacy": "Privacy",
    "sellerInfo": "Seller Info"
  },
  "serviceEdit": {
    "title": "Edit Service",
    "backToList": "← Back to list",
    "created": "Created",
    "updated": "Updated",
    "description": "Description",
    "descriptionRequired": "Description is required",
    "serviceUrl": "Service URL",
    "serviceUrlRequired": "Please enter a valid URL",
    "devCountry": "Country",
    "devCountryPlaceholder": "e.g., USA, Japan, China",
    "personalNotes": "My Notes",
    "personalNotesMarkdown": "Markdown format",
    "personalNotesPlaceholder": "- [Link](URL)\n- Note\n- Task",
    "personalNotesMaxLength": "Notes must be within 500 characters",
    "personalNotesCharCount": "{{count}}/500 characters",
    "defaultMemoTitle": "📌 Show default memo",
    "tags": "Tags",
    "saving": "Saving...",
    "save": "💾 Save",
    "cancel": "✕ Cancel",
    "customized": "Customized",
    "resetButton": "Reset",
    "resetDialogTitle": "Reset to default settings?",
    "resetDialogDescription": "All customizations for this service (description, pricing, model, URL, API URL, your notes, tags, etc.) will be reset to default settings.\nDefault memo (organization level) will not be deleted.\nThis action cannot be undone.",
    "resetDialogCancel": "Cancel",
    "resetting": "Resetting...",
    "resetDialogConfirm": "Reset",
    "notFound": "Service not found",
    "notFoundDescription": "The service with the specified ID does not exist or\nyou may not have permission to access it.",
    "backToServices": "Back to service list",
    "saveSuccess": "Saved",
    "saveSuccessDescription": "Service information has been updated successfully",
    "saveError": "Failed to save",
    "resetSuccess": "Reset completed",
    "resetSuccessDescription": "Restored to default settings",
    "resetError": "Failed to restore to default settings",
    "requiredField": "*",
    "ariaLabelResetToDefault": "Reset to default settings",
    "ariaLabelOpenServiceUrl": "Open service URL"
  },
  "planGate": {
    "editRequiresPro": "Editing items is a Pro feature",
    "editRequiresProDescription": "Upgrade to Pro to edit service details and save your notes.",
    "viewPricing": "View pricing"
  },
  "userService": {
    "addButton": "Add My Item",
    "addTitle": "Add My Service",
    "addDescription": "Add your own private service ({{remaining}}/{{max}} remaining)",
    "editTitle": "Edit My Service",
    "editDescription": "Edit your private service information",
    "name": "Service Name",
    "namePlaceholder": "e.g., My ChatGPT Custom",
    "nameRequired": "Service name is required",
    "url": "URL",
    "urlInvalid": "Please enter a valid URL",
    "provider": "Provider",
    "providerPlaceholder": "e.g., OpenAI",
    "logoUrl": "Logo URL",
    "logoUrlInvalid": "Please enter a valid URL",
    "description": "Description",
    "descriptionPlaceholder": "Brief description of the service",
    "releaseDate": "Release Date",
    "devCountry": "Country Code",
    "devCountryPlaceholder": "e.g., US, JP",
    "personalNotes": "Personal Notes",
    "personalNotesPlaceholder": "Your private notes about this service",
    "notesMaxLength": "Notes must be within 500 characters",
    "tags": "Tags",
    "save": "Save",
    "saving": "Saving...",
    "cancel": "Cancel",
    "delete": "Delete",
    "deleting": "Deleting...",
    "createSuccess": "Service Created",
    "createSuccessDescription": "Your service has been added successfully",
    "updateSuccess": "Service Updated",
    "updateSuccessDescription": "Your service has been updated successfully",
    "deleteSuccess": "Service Deleted",
    "deleteSuccessDescription": "Your service has been removed",
    "saveError": "Failed to save service",
    "deleteError": "Failed to delete service",
    "deleteDialogTitle": "Delete Service?",
    "deleteDialogDescription": "Are you sure you want to delete \"{{name}}\"? This action cannot be undone.",
    "deleteDialogCancel": "Cancel",
    "deleteDialogConfirm": "Delete",
    "limitReached": "You have reached the maximum number of services ({{max}})",
    "badge": "My Service"
  },
  "cookieConsent": {
    "banner": {
      "title": "Cookie Notice",
      "description": "We use essential cookies to provide our service. You can customize analytics and advertising cookies in settings.",
      "privacyPolicyLink": "Privacy Policy",
      "rejectAll": "Reject All",
      "rejectAllAria": "Reject all non-essential cookies",
      "preferences": "Preferences",
      "preferencesAria": "Open cookie preferences",
      "acceptAll": "Accept All",
      "acceptAllAria": "Accept all cookies"
    },
    "preferences": {
      "title": "Cookie Preferences",
      "description": "Manage cookie usage by category.",
      "required": "Required",
      "examplesPrefix": "Examples: ",
      "privacyPolicyLink": "Privacy Policy",
      "rejectAll": "Reject All",
      "saveSelection": "Save Selection",
      "acceptAll": "Accept All"
    },
    "categories": {
      "essential": {
        "name": "Essential Cookies",
        "description": "Required for basic site functionality (login, security)."
      },
      "functional": {
        "name": "Functional Cookies",
        "description": "Remember your settings (language, theme, etc.)."
      },
      "analytics": {
        "name": "Analytics Cookies",
        "description": "Analyze site usage anonymously for improvements."
      },
      "advertising": {
        "name": "Advertising Cookies",
        "description": "Used for targeted ads and affiliate tracking."
      }
    },
    "settings": {
      "buttonAria": "Open cookie settings"
    }
  },
  "accessibility": {
    "skipToMain": "Skip to main content"
  },
  "swrError": {
    "title": "An error occurred",
    "networkMessage": "Unable to connect to network",
    "defaultMessage": "Failed to load data",
    "retry": "Try again"
  },
  "landing": {
    "header": {
      "features": "Features",
      "pricing": "Pricing",
      "faq": "FAQ",
      "login": "Login",
      "getStartedFree": "Get Started Free",
      "openMenu": "Open menu",
      "desktopNav": "Main navigation",
      "mobileNav": "Mobile navigation",
      "goToDashboard": "Dashboard",
      "themeToLight": "Switch to light mode",
      "themeToDark": "Switch to dark mode"
    },
    "hero": {
      "badge": "AI Tool Management App",
      "titleLine1": "Build a deck",
      "titleLine2": "of your favorite AI tools.",
      "subtitle": "Never lose track of your AI tools again.",
      "getStartedFree": "Get Started Free",
      "login": "Login",
      "servicesCount": "630+",
      "servicesRegistered": "AI services registered",
      "screenshotAlt": "AI Deck application screenshot",
      "signupNote": "Sign up in about 30 seconds with email, Google, or GitHub"
    },
    "latestArticles": {
      "title": "Recently added AI tools",
      "subtitle": "Fresh guides for the newest services in the catalog.",
      "viewAll": "Browse all guides"
    },
    "campaign": {
      "banner": "🎁 Launch campaign: RT the campaign post + sign up by Aug 19 → Pro features free for life (everything except ad removal)"
    },
    "features": {
      "titleLine1": "Powerful features to",
      "titleLine2": "manage AI tools with ease",
      "subtitleLine1": "Search, organize, and customize.",
      "subtitleLine2": "Everything you need, all in one place.",
      "search": {
        "title": "Find it in seconds, from {{servicesCount}}",
        "description": "Filter by keyword and tags to reach the right AI service fast. New services are added regularly.",
        "imageAlt": "AI Deck service list screen"
      },
      "links": {
        "title": "Official info, one click away",
        "description": "Hover to reveal related links — docs, pricing, SNS, and API pages, right when you need them.",
        "imageAlt": "Related links popup opened on hover"
      },
      "colors": {
        "title": "Groups × 7 color labels",
        "description": "Organize by purpose and identify at a glance. Reorder freely with drag & drop.",
        "imageAlt": "Deck organized with groups and color labels"
      },
      "views": {
        "title": "3 switchable views",
        "description": "Minimal, Compact, Full — pick the density that feels right.",
        "viewMinimal": "Minimal",
        "viewCompact": "Compact",
        "viewFull": "Full"
      },
      "memo": {
        "title": "Private Memos",
        "description": "Local-only, never stored in our database. Keep personal notes safely.",
        "memoLabel": "Notes just for you"
      },
      "customize": {
        "title": "Make the deck yours",
        "description": "Add your own services and edit existing ones — even internal tools can join your deck.",
        "fieldName": "Service name",
        "sampleName": "Internal GPT Lab"
      }
    },
    "benefits": {
      "eyebrow": "Sound familiar?",
      "title": "AI Deck solves it all!",
      "subtitle": "Better than browser bookmarks — more comfortable and convenient!",
      "item0": {
        "problem": "Too many AI tools — hard to know which one to use",
        "solution": "Keyword search and tag filtering help you find the right service instantly.",
        "imageAlt": "Illustration of a magnifying glass finding one card among many"
      },
      "item1": {
        "problem": "AI portal sites aren't built for personal management",
        "solution": "Enjoy a clean, organized card view designed for easy browsing.",
        "imageAlt": "Illustration of cards neatly arranged with color labels"
      },
      "item2": {
        "problem": "Browser bookmarks pile up and become hard to navigate",
        "solution": "Favorite your go-to tools for one-click access.",
        "imageAlt": "Illustration of a fanned hand of cards marked with hearts"
      },
      "item3": {
        "problem": "Can't remember what each service does",
        "solution": "Hover over a logo for a quick summary. Add your own personal notes too.",
        "imageAlt": "Illustration of a card with a sticky note and pen"
      }
    },
    "howItWorks": {
      "title": "Super easy to use!",
      "subtitle": "Build your personal AI deck with simple actions.",
      "cta": "Build your deck for free",
      "ctaNote": "Start at $0 — pick your starters from {{servicesCount}} services.",
      "memoLabel": "Memo",
      "proChip": "Edit with Pro",
      "step0": {
        "title": "Favorite the services you love",
        "description": "On the service list page, tap the heart icon to add services to your deck."
      },
      "step1": {
        "title": "Reorder & group to your liking",
        "description": "Drag and drop to reorder intuitively. Group and color-label for easy identification."
      },
      "step2": {
        "title": "Add memos & edit details",
        "description": "Write private memos. Pro plan lets you add services and customize details."
      }
    },
    "pricing": {
      "title": "Pricing Plans",
      "subtitleLine1": "The free plan is plenty powerful.",
      "subtitleLine2": "Create an account now and build your AI deck!",
      "recommendedBadge": "Start Here",
      "freePlan": "Free Plan",
      "proPlan": "Pro Plan",
      "freePlanPrice": "$0",
      "noCreditCard": "No credit card required",
      "monthlyBilling": "Monthly",
      "yearlyBilling": "Yearly",
      "perMonth": "/mo",
      "yearlyTotal": "Annual total: {{price}}",
      "yearlySavings": "{{months}} months free",
      "monthlyTotal": "Monthly billing ({{price}}/year)",
      "createFreeAccount": "Create Free Account",
      "startProPlan": "Start Pro Plan",
      "startProPlanMonthly": "Start Pro Plan (Monthly)",
      "startProPlanYearly": "Start Pro Plan (Yearly)",
      "freeFeatures": {
        "item0": "Access to a large library of AI tools & services",
        "item1": "Grouping & color labels",
        "item2": "Fast search & tag filtering",
        "item3": "Private memos",
        "item4": "Cannot add or edit"
      },
      "proFeatures": {
        "item0": "All free plan features",
        "item1": "Add custom items",
        "item2": "Edit existing items",
        "item3": "Ad-free experience",
        "item4": "Priority support",
        "item5": "All future features included"
      },
      "yearlyPriceNote": "With yearly billing (per month)",
      "monthlyPriceNote": "With monthly billing"
    },
    "developers": {
      "title": "Use it from outside, via API and MCP",
      "subtitle": "AI Deck doesn't stop at the app. A read-only public API and a built-in MCP server come standard — connect from Claude, ChatGPT, and major coding agents via MCP to search the catalog and get recommendations right where you work. No API key needed to try it.",
      "clientsMore": "+ any MCP client",
      "terminalTitle": "AI agent",
      "terminalPrompt": "Recommend go-to video generation tools from my deck",
      "terminalRunning": "ai-deck: running recommend_services…",
      "terminalDone": "Returned 3 recommendations from the catalog",
      "cta": "Read the developer docs"
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "item0": {
        "question": "Is AI Deck really free?",
        "answer": "Yes, it's completely free to use. No credit card registration required."
      },
      "item1": {
        "question": "What kind of AI services are registered?",
        "answer": "From popular services to niche ones, a wide range of AI-related services are registered. We regularly add more. If there's a service you'd like added, please submit a request through the registration form."
      },
      "item2": {
        "question": "Is my data stored safely?",
        "answer": "Yes, your data is stored safely. Your customization data is never shared with other users. \"Private Memos\" are stored on your device only, so they're never even recorded on our servers."
      },
      "item3": {
        "question": "Can I use it on my smartphone?",
        "answer": "Yes. AI Deck uses responsive design and works on smartphones and tablets. However, it's optimized for the best experience on PC."
      },
      "item4": {
        "question": "Can I delete my account?",
        "answer": "Yes, you can delete your account anytime. You can easily do so from the settings page."
      }
    },
    "finalCta": {
      "titleLine1": "Build your personal AI deck",
      "titleLine2": "right now",
      "subtitle": "The free plan is plenty powerful!",
      "cta": "Build Your Deck Now"
    },
    "footer": {
      "description": "Build a deck of your favorite AI tools.",
      "product": "Product",
      "freeSignup": "Free Sign Up",
      "login": "Login",
      "pricing": "Pricing",
      "changelog": "Changelog",
      "support": "Support",
      "userGuide": "User Guide",
      "faq": "FAQ",
      "contact": "Contact",
      "legal": "Terms & Policies",
      "terms": "Terms of Service",
      "privacy": "Privacy Policy",
      "commercial": "Commercial Disclosure",
      "refund": "Refund & Cancellation Policy",
      "developers": "Developer API"
    },
    "pricingPage": {
      "heroTitle": "Pricing Plans",
      "heroSubtitleLine1": "The free plan is plenty powerful.",
      "heroSubtitleLine2": "Upgrade to Pro for an even better AI management experience.",
      "recommendedBadge": "Start Here",
      "freePlan": "Free Plan",
      "proPlan": "Pro Plan",
      "noCreditCard": "No credit card required",
      "getStartedFree": "Get Started Free",
      "startProPlan": "Start Pro Plan",
      "startProPlanMonthly": "Start Pro Plan (Monthly)",
      "startProPlanYearly": "Start Pro Plan (Yearly)",
      "comparisonTitle": "Feature Comparison",
      "feature": "Feature",
      "comparisonFeatures": {
        "item0": "Search, browse & add AI services to decks",
        "item1": "Favorites",
        "item2": "Max decks (groups)",
        "item3": "Search & filter",
        "item4": "Color labels",
        "item5": "Private memos",
        "item6": "Ad-free",
        "item7": "Customize each item (URL, descriptions & notes)",
        "item8": "Edit tags",
        "item9": "Priority support"
      },
      "comparisonValues": {
        "unlimited": "Unlimited",
        "maxDecks": "Up to 10"
      },
      "campaignProNote": "* Users on a past campaign plan have access to all Pro features, with ads displayed.",
      "paymentTitle": "Payment Methods",
      "paymentItems": {
        "item0": "Credit cards (Visa, Mastercard, JCB, American Express)",
        "item1": "Debit cards",
        "item2": "* Payments securely processed by Polar Software, Inc."
      },
      "securityTitle": "Security",
      "securityItems": {
        "item0": "SSL encrypted communication",
        "item1": "Card info securely managed by payment processor",
        "item2": "We never store your card information"
      },
      "cancellationTitle": "Cancellation & Refunds",
      "cancellationItems": {
        "item0": "Cancel anytime",
        "item1": "Access continues until end of billing period",
        "item2": "See refund policy details below"
      },
      "cancellationLink": "View Refund Policy",
      "contactTitle": "Contact Us",
      "contactItems": {
        "item0": "Questions about pricing? Feel free to ask",
        "item1": "Reach out via the feedback page"
      },
      "contactLink": "Contact Us",
      "faqTitle": "Pricing FAQ",
      "faq": {
        "item0": {
          "question": "What's the difference between the free and paid plans?",
          "answer": "The free plan includes all basic features (browsing services, favorites, search, etc.). The Pro plan adds ad-free experience, item customization (URL, descriptions & notes), priority support, and more."
        },
        "item1": {
          "question": "Is yearly or monthly billing better value?",
          "answer": "Yearly billing comes to about $1.50/month ($17.99/year) — that's 3 months free compared to monthly billing ($1.99/month × 12 = $23.88)."
        },
        "item2": {
          "question": "What payment methods are accepted?",
          "answer": "Credit cards (Visa, Mastercard, JCB, American Express) and debit cards are accepted. Payments are securely processed by Polar Software, Inc."
        },
        "item3": {
          "question": "Can I cancel anytime?",
          "answer": "Yes, you can cancel anytime. After cancellation, you'll continue to have access to Pro plan features until the end of your billing period."
        }
      },
      "viewAllFaq": "View all FAQs →",
      "ctaTitle": "Why not start for free?",
      "ctaSubtitleLine1": "No credit card needed to get started.",
      "ctaSubtitleLine2": "Upgrade to Pro anytime.",
      "ctaUpgradeTitle": "Ready to upgrade to Pro?",
      "ctaUpgradeSubtitleLine1": "Add and edit your own AI tools freely.",
      "ctaUpgradeSubtitleLine2": "Enjoy ad-free browsing, priority support, and all Pro features.",
      "ctaProTitle": "Thank you for being a Pro member",
      "ctaProSubtitle": "Enjoy all Pro features.",
      "manageSubscription": "Manage Subscription",
      "currentPlan": "Current Plan",
      "billingError": "Couldn't open the checkout page",
      "billingErrorDescription": "Please try again in a moment. If the problem persists, contact us.",
      "ctaButton": "Get Started Free",
      "backToHome": "← Back to Home"
    }
  },
  "publishDeck": {
    "titleNew": "Publish your deck",
    "titleEditing": "Published deck",
    "subtitleNew": "Publish your current deck as a shareable URL for social media.",
    "subtitleEditing": "Change publish settings and re-publish. After updating, press \"Update & publish\".",
    "devWarningTitle": "⚠️ Dev environment — this URL only becomes reachable after the production deploy",
    "devWarningHint": "To preview locally, open <1>{{url}}</1> directly.",
    "publicUrlLabel": "Public URL",
    "shareButton": "Share",
    "copyUrlButton": "Copy URL",
    "settingsLegend": "Publish settings",
    "includeNotesLabel": "Include personal notes",
    "includeNotesDescription": "Personal notes you've written for each service will appear on the public page",
    "includeUserOwnedLabel": "Include my services",
    "includeUserOwnedDescription": "Services you've added yourself will appear on the public page",
    "affiliateNoteTitle": "About the links",
    "affiliateNoteFree": "On the public page, some service cards link through an affiliate URL (Free and lifetime Pro plans). On the Pro plan they keep the service's official URL.",
    "titleLabel": "Title (optional)",
    "titlePlaceholder": "My AI deck",
    "descriptionLabel": "Description (optional)",
    "descriptionPlaceholder": "A short description of this deck",
    "unpublishButton": "Unpublish",
    "publishButton": "Publish",
    "updatePublishButton": "Update & publish",
    "shareTitle": "My AI deck",
    "shareText": "I just published my AI deck",
    "toast": {
      "errorTitle": "Error",
      "publishSuccessTitle": "Deck published",
      "updateSuccessTitle": "Publish settings updated",
      "publishSuccessDescription": "Share the URL and let others see your deck",
      "publishErrorDefault": "Failed to publish",
      "unpublishSuccessTitle": "Unpublished",
      "unpublishSuccessDescription": "The URL will be restored when you re-publish",
      "unpublishErrorDefault": "Failed to unpublish",
      "copySuccess": "URL copied",
      "copyErrorTitle": "Failed to copy URL",
      "copyErrorDescription": "Please check your browser's permission settings"
    },
    "unpublishDialog": {
      "title": "Unpublish this deck?",
      "description": "URLs already shared on social media will become temporarily unreachable. Re-publishing restores the same URL.",
      "cancel": "Cancel",
      "confirm": "Unpublish"
    }
  },
  "publicDeck": {
    "defaultTitle": "{{name}}'s AI deck",
    "anonymous": "Anonymous user",
    "metaDescription": "A deck of {{count}} AI services",
    "serviceCount_one": "{{count}} service",
    "serviceCount": "{{count}} services",
    "areaCount_one": "{{count}} area",
    "areaCount": "{{count}} areas",
    "updatedOn": "Updated {{date}}",
    "areaNavLabel": "Areas",
    "viewToggleLabel": "View",
    "viewCard": "Cards",
    "viewList": "List",
    "areaFallback": "Area {{area}}",
    "otherArea": "Other",
    "empty": "This deck has no published services",
    "openService": "Open {{name}}",
    "readMore": "Read more",
    "showLess": "Show less",
    "officialNote": "Official note",
    "ownerNote": "Publisher's note",
    "moreTags_one": "{{count}} more tag",
    "moreTags": "{{count}} more tags",
    "loading": "Loading public deck",
    "errorTitle": "Failed to load",
    "errorMessage": "Could not fetch the deck. Please try again in a moment.",
    "notFoundTitle": "This deck is not public",
    "notFoundMessage": "The URL may be wrong, or the owner may have unpublished it.",
    "backHome": "Go to {{site}} home",
    "poweredBy": "Powered by {{site}}",
    "cta": "Build your own AI deck",
    "topNavCta": "Build your own deck →"
  },
  "serviceRequest": {
    "title": "Request New Service",
    "description": "Request an AI service to be added",
    "triggerButton": "Request Item",
    "serviceName": "Service Name",
    "serviceNamePlaceholder": "e.g., ChatGPT, Claude, etc.",
    "serviceUrl": "Service URL",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "Briefly describe what this service does",
    "descriptionRequired": "Description is required",
    "reasoning": "Notes (Optional)",
    "reasoningPlaceholder": "Any additional information",
    "categorySuggestion": "Suggested Category (Tags)",
    "nameRequired": "Service name is required",
    "urlInvalid": "Please enter a valid URL",
    "submit": "Submit Request",
    "submitting": "Submitting...",
    "cancel": "Cancel",
    "submitSuccess": "Submitted",
    "submitSuccessDescription": "Your service request has been submitted. Please wait for admin review.",
    "submitError": "Submission Error",
    "unknownError": "An unknown error occurred",
    "duplicateError": "Duplicate Error",
    "existingService": "Existing service",
    "existingRequest": "Pending request",
    "noDuplicate": "This URL is not registered",
    "rateLimitInfo": "Remaining requests: {{remaining}}/{{limit}}",
    "rateLimitExceeded": "Request limit reached. Please try again in 1 hour.",
    "checking": "Checking..."
  },
  "tour": {
    "buttons": {
      "next": "Next",
      "prev": "Back",
      "done": "Done"
    },
    "progressText": "Step {{current}} of {{total}}",
    "restart": "Replay the tour",
    "restartTooltip": "Replay the guided tour from the beginning",
    "deck": {
      "welcome": {
        "title": "Welcome to AI Deck",
        "body": "Build a deck of your favorite AI tools. Let us walk you through the basics in 30 seconds."
      },
      "addService": {
        "title": "Add from Service List",
        "body": "Browse and add AI services from the 'Service List' in the main menu. You can also register up to 100 personal services."
      },
      "favorite": {
        "title": "Favorites",
        "body": "Tap the heart to favorite a service. Favorited services appear on your home deck automatically."
      },
      "tagFilter": {
        "title": "Filter by tags",
        "body": "Narrow down services by purpose or category. Combine multiple tags for finer filtering."
      },
      "search": {
        "title": "Search",
        "body": "Search across names, descriptions, and tags. A keyboard shortcut is available for quick access."
      },
      "serviceLogo": {
        "title": "Hover the logo for a summary",
        "body": "Hover (or tap on mobile) a service logo to see a quick description of that service."
      },
      "serviceMemo": {
        "title": "List icon for links & notes",
        "body": "Hover (or tap on mobile) the list icon to see official links and your personal notes for that service."
      },
      "dnd": {
        "title": "Drag to reorder",
        "body": "Reorder cards by dragging. Put the services you use most at the top."
      },
      "userMenu": {
        "title": "Your menu lives here",
        "body": "Find user settings and \"Replay the tour\" inside this menu. Open it whenever you need help."
      }
    },
    "pro": {
      "welcome": {
        "title": "Welcome to Pro",
        "body": "A quick 30-second tour of what's new in your Pro plan."
      },
      "adFree": {
        "title": "Ad-free experience",
        "body": "All ads are fully hidden on the Pro plan so you can focus on your deck."
      },
      "userServices": {
        "title": "Up to 100 personal services",
        "body": "Add up to 100 of your own services—internal tools or niche AI you rely on—organized just for you."
      },
      "portal": {
        "title": "Manage your plan",
        "body": "Billing details, invoices, and cancellation are available anytime from the billing section in user settings."
      }
    }
  },
  "developers": {
    "heroTitle": "Developer API",
    "heroSubtitle": "Use the {{appName}} AI service catalog from your own apps and agents.",
    "copy": "Copy",
    "overview": {
      "title": "Overview",
      "body": "The {{appName}} public API is a read-only AI service catalog API. You can fetch services, details, tags, public decks, and stats as JSON. Writes and access to personal data are not supported.",
      "attribution": "When you display data from the API, attribution to {{appName}} (https://ai-deck.app) via a link is required. Every response includes aiDeckUrl and attribution fields."
    },
    "urlNote": "The service url field depends on the plan. Free keys return affiliate links (only for services where it's allowed); Pro keys return the official URL. In both cases aiDeckUrl points to the AI Deck service page.",
    "auth": {
      "title": "Authentication",
      "body": "All endpoints except stats require an API key. Pass it as a Bearer token in the Authorization header.",
      "getKey": "Create a key in the \"API Keys\" tab of Settings →"
    },
    "endpoints": {
      "title": "Endpoints",
      "method": "Method",
      "path": "Path",
      "description": "Description",
      "auth": "Auth",
      "authRequired": "API key",
      "authNone": "None",
      "list": {
        "services": "Public service list (search, tags, country, sort, pagination)",
        "serviceDetail": "Service details",
        "tags": "Tag list (with ecosystem / function / attribute category)",
        "stats": "Public stats (total service count, etc.)",
        "decks": "Public deck list",
        "deckDetail": "Public deck details"
      }
    },
    "examples": {
      "title": "Examples",
      "intro": "Replace adk_live_xxx with the key you created.",
      "listLabel": "Search and fetch services",
      "detailLabel": "Fetch service details",
      "statsLabel": "Fetch stats (no key required)"
    },
    "mcp": {
      "title": "MCP Server",
      "intro": "The catalog is also available as an MCP (Model Context Protocol) server. Connect it to AI agents such as Claude or Cursor to search and reference AI services directly from a conversation.",
      "endpointLabel": "Endpoint (Streamable HTTP)",
      "authNote": "Works without an API key (anonymous: 50 req/min, 100 req/day per IP). Send your API key via the Authorization: Bearer header to get your plan's limits (free: 1,000 req/day, Pro: 10,000 req/day); the plan-based url field behaves the same as the REST API.",
      "methodNote": "The endpoint accepts POST only (JSON-RPC over Streamable HTTP). GET and DELETE return 405.",
      "connectTitle": "Connect",
      "claudeAiLabel": "Claude.ai / Claude Desktop",
      "claudeAiBody": "In Settings > Connectors, choose \"Add custom connector\" and paste the endpoint URL above.",
      "cursorLabel": "Cursor (~/.cursor/mcp.json)",
      "toolsTitle": "Available tools",
      "toolName": "Tool",
      "toolDesc": "Description",
      "toolRequires": "Auth required",
      "requiresNone": "None",
      "requiresKey": "API key",
      "requiresWrite": "read_write key",
      "tools": {
        "searchServices": "Search the catalog (query, tags, country, sort, pagination)",
        "recommendServices": "Rank the catalog for a goal described in plain language, with a match-quality signal",
        "getService": "Full details of one service (related links, logo, flags)",
        "listTags": "Tag vocabulary grouped by facet (ecosystem / function / attribute)",
        "searchDecks": "List public decks",
        "getDeck": "Contents of one public deck (with its services)",
        "getStats": "Catalog statistics (total public services). Works without a key — handy as a connection check",
        "getMyDeck": "Read your own deck (areas + favorites) in its current state. Private memos are never included",
        "addToDeck": "Add a service to your deck. Matches the catalog by name and URL; outside the catalog, Pro users get it created as a private service",
        "moveInDeck": "Move a service to another area of your deck or reorder it",
        "requestServiceAddition": "Ask the AI Deck team to add a service to the catalog (any plan)"
      },
      "scopeTitle": "Key scopes",
      "scopeBody": "API keys come in two scopes: read-only (read) and read & write (read_write). The deck-writing tools (add_to_deck / move_in_deck / request_service_addition) require a key with the read_write scope. You choose the scope when creating a key; the default is read-only. All existing keys are treated as read-only, and a key's scope cannot be changed later (create a new key if you need read_write). Writing always targets the key owner's own deck only.",
      "rateNote": "See \"Rate limits\" below for quotas. An invalid API key returns 401 (no silent fallback to anonymous access)."
    },
    "rateLimits": {
      "title": "Rate limits",
      "intro": "Rate limits depend on the key owner's plan (shared across REST and MCP). Keyless MCP access uses a per-IP anonymous quota. Exceeding them returns 429.",
      "plan": "Plan",
      "perMinute": "Per minute",
      "perDay": "Per day",
      "mcpAnon": "MCP (no key / anonymous)",
      "free": "Free",
      "pro": "Pro",
      "proNote": "The Pro quota also applies to keys on the campaign_pro (lifetime Pro) plan.",
      "statsNote": "Only stats can be called without an API key; a per-IP, per-minute rate limit ({{perMinute}} req/min) applies.",
      "note": "Each response includes X-RateLimit-Limit / X-RateLimit-Remaining / X-RateLimit-Reset headers. Initial limits are conservative and may be raised based on demand."
    },
    "terms": {
      "title": "Terms of use",
      "item1": "Redistributing full dumps is prohibited. Do not redistribute or resell the catalog data as-is to third parties.",
      "item2": "Cache retention is limited to 24 hours.",
      "item3": "Attribution to AI Deck via a link is required when displaying data.",
      "item4": "Do not modify affiliate parameters.",
      "item5": "The API is provided as-is. Availability, accuracy, and continued operation are not guaranteed, and the specification, rate limits, and scope may change or be discontinued without notice.",
      "item6": "These terms may change without notice. Continuing to use the API after a change means you accept it.",
      "baseTermsPrefix": "Anything not covered here follows the ",
      "baseTermsSuffix": ".",
      "violation": "Violating these terms may result in your API key being revoked."
    },
    "compat": {
      "title": "Compatibility policy",
      "body": "The API version is fixed at v1 in the path /api/public/v1. Fields may be added as non-breaking changes without notice. Field removals or renames will be delivered as v2, and any deprecation of an existing version will be announced in advance whenever possible."
    },
    "toc": {
      "title": "Contents"
    },
    "reference": {
      "title": "API reference",
      "intro": "Specifications for each endpoint's query parameters, response fields, errors, and rate-limit headers. The server implementation is the source of truth; fields may be added in a non-breaking way.",
      "common": {
        "title": "Common specification",
        "envelopeTitle": "Response envelope",
        "envelopeBody": "Every response is wrapped in an envelope with data and meta. List endpoints include pagination info in meta; item endpoints include only attribution. tags includes total in meta.",
        "envelopeList": "List (services / decks)",
        "envelopeItem": "Item (services/:id / decks/:id)",
        "envelopeTags": "Tag list (tags)",
        "envelopeStats": "Stats (stats)",
        "errorsTitle": "Errors",
        "errorsNote": "On error, an HTTP status and an error field (string) are returned. 5xx message text may change in the future, so rely on the status code for handling.",
        "headersTitle": "Rate-limit headers",
        "headersNote": "Key-required endpoints return daily (-Day) headers in addition to the per-minute headers. stats is keyless and IP-based, so it returns only the per-minute headers with no daily headers. Retry-After is only present on 429.",
        "colName": "Name",
        "colType": "Type",
        "colRequired": "Required",
        "colDefault": "Default",
        "colConstraint": "Constraint",
        "colDescription": "Description",
        "colNullable": "Nullable",
        "colStatus": "Status",
        "colBody": "Response body",
        "colHeader": "Header",
        "requiredYes": "Required",
        "requiredNo": "Optional",
        "nullableYes": "Yes",
        "nullableNo": "—"
      },
      "params": {
        "q": "Partial match against name / provider / description / descriptionEn (case-insensitive).",
        "tags": "Comma-separated tag IDs. Tags within the same category are ORed; across categories they are ANDed. Unknown tag IDs are treated as the function category.",
        "country": "Exact match on the developer country code (devCountry), case-insensitive.",
        "sort": "Sort order. name (name ascending) / release_date (newest first, nulls last) / popularity (favorite count descending). Unspecified or invalid values use the catalog's default order.",
        "page": "Page number (1-based).",
        "perPage": "Items per page. Out-of-range values are clamped to 1–100."
      },
      "pathParams": {
        "serviceId": "Service ID (same value as a service's id).",
        "deckId": "Deck slug (alphanumeric, _, -, 6–32 chars)."
      },
      "fields": {
        "service": {
          "id": "Service ID (unique slug used in the URL).",
          "name": "Service name.",
          "provider": "Provider.",
          "url": "Destination URL. Plan-dependent (free keys return affiliate links for eligible services; Pro keys return the official URL).",
          "aiDeckUrl": "AI Deck service page URL (attribution link).",
          "logoUrl": "Logo image URL or path.",
          "description": "Description (Japanese).",
          "descriptionEn": "Description (English).",
          "releaseDate": "Release date (YYYY-MM-DD).",
          "devCountry": "Developer country code (e.g. US, JP).",
          "mcpDocsUrl": "URL of the service's official MCP documentation page (null when unverified or not offered).",
          "links": "Related links (only the keys that exist, among home / document / github / x, etc.).",
          "tags": "Array of tags (each has id / name / nameEn / category).",
          "isEditorPick": "Whether it's an editor's pick.",
          "isTrending": "Whether it's trending.",
          "isPopular": "Whether it's popular.",
          "createdAt": "Date the service was added to the AI Deck catalog (ISO 8601).",
          "updatedAt": "Last update time of the catalog entry (ISO 8601)."
        },
        "tag": {
          "id": "Tag ID (the value to pass to the tags parameter).",
          "name": "Tag name (Japanese).",
          "nameEn": "Tag name (English).",
          "category": "Category (ecosystem / function / attribute)."
        },
        "deck": {
          "slug": "Deck slug.",
          "url": "Public deck URL.",
          "version": "Published version.",
          "title": "Deck title (null if unset).",
          "description": "Deck description (null if unset).",
          "serviceCount": "Number of services in the deck.",
          "snapshot": "Snapshot of the deck composition (an object with order, titles, services, author, etc.).",
          "publishedAt": "Published timestamp (ISO 8601).",
          "updatedAt": "Updated timestamp (ISO 8601)."
        },
        "stats": {
          "totalServices": "Total number of public services."
        }
      },
      "errors": {
        "e401": "API key missing or invalid.",
        "e404": "Resource not found (Service not found for services, Deck not found for decks). Requests to an unknown path return Not Found.",
        "e429": "Rate limit (per-minute or per-day) exceeded. Returns retryAfter (seconds) along with the Retry-After header.",
        "e500": "Internal server error."
      },
      "headers": {
        "limitMinute": "Per-minute request limit.",
        "remainingMinute": "Remaining requests in the current minute window.",
        "resetMinute": "Time the minute window resets (epoch seconds).",
        "limitDay": "Per-day request limit.",
        "remainingDay": "Remaining requests in the current day window.",
        "resetDay": "Time the day window resets (epoch seconds).",
        "retryAfter": "Seconds to wait before retrying (only on 429)."
      },
      "tagCategories": {
        "ecosystem": "A specific ecosystem or platform (e.g. Claude Code, Hermes Agent).",
        "function": "Function or use case (e.g. image generation, coding).",
        "attribute": "Delivery form or attribute (e.g. CLI, AI agent, MCP)."
      },
      "examples": {
        "title": "Response example",
        "truncated": "* data is abbreviated for brevity (lists show a few items; links and tags show only some entries). See the response-field table for /services for the full set."
      },
      "labels": {
        "params": "Query parameters",
        "pathParams": "Path parameters",
        "fields": "Response fields",
        "example": "Response example",
        "categoryMeaning": "Meaning of category",
        "servicesDetailNote": "data has the same shape as an element of /services. A nonexistent id returns 404 (Service not found).",
        "decksDetailNote": "If the slug doesn't match the format (alphanumeric, _, -, 6–32 chars) or doesn't exist, returns 404 (Deck not found).",
        "statsNote": "The only endpoint callable without a key. A per-IP, per-minute rate limit ({{perMinute}} req/min) applies.",
        "tagsFilterNote": "category drives the tags filter: OR within the same category, AND across categories.",
        "backToEndpoints": "Back to endpoints",
        "ref": "Spec"
      }
    }
  },
  "notFoundPage": {
    "title": "Page not found",
    "description": "The page you are looking for may have been moved or deleted, or the URL may be incorrect.",
    "backToHome": "Back to Home",
    "dashboard": "Dashboard",
    "services": "Services"
  }
}
